/**
 * Slider con control de navegación y bloqueo del loop hacia atrás
 */
var Sliders = (function($) {
  function initHomeSlider() {
    const swiper = new Swiper(".home-hero-slider", {
      loop: true,
      // autoplay: {
      //   delay: 7000
      // },
      effect: "fade",
      speed: 1000,
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
      // on: {
      //   init: function() {
      //     updateNavPosition(this);
      //     $(".swiper-button-prev").hide();
      //   },
      //   slideChangeTransitionEnd: function() {
      //     updateNavPosition(this);
      //     $(".swiper-button-prev").show();
      //   }
      // }
    });
  }

  function initProjectSlider() {
    const $slider = $(".project-hero-slider");
    const swiper = new Swiper(".project-hero-slider", {
      loop: true,
      // autoplay: {
      //   delay: 7000
      // },
      effect: "fade",
      speed: 1000,
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }

      // on: {
      //   init: function() {
      //     updateNavPosition(this);
      //     $(".swiper-button-prev").hide();
      //   },
      //   slideChangeTransitionEnd: function() {
      //     updateNavPosition(this);
      //     $(".swiper-button-prev").show();
      //   }
      // }
    });
    // Cursores personalizados (ajusta rutas)
    const themeUrl = window.location.origin + "/wp-content/themes/mdba";
    const cursorLeft = `url(${themeUrl}/inc/svg/arrow-left.svg), auto`;
    const cursorRight = `url(${themeUrl}/inc/svg/arrow-right.svg), auto`;

    // Detecta la mitad y cambia el cursor
    $slider.on("mousemove", function(e) {
      const offset = $(this).offset();
      const width = $(this).outerWidth();
      const x = e.pageX - offset.left;

      if (x < width / 2) {
        $(this).css("cursor", cursorLeft);
        $(this).attr("data-cursor-side", "left");
      } else {
        $(this).css("cursor", cursorRight);
        $(this).attr("data-cursor-side", "right");
      }
    });

    $slider.on("mouseleave", function() {
      $(this)
        .css("cursor", "auto")
        .removeAttr("data-cursor-side");
    });

    // Click → según la mitad, cambia de slide
    $slider.on("click", function(e) {
      const side = $(this).attr("data-cursor-side");
      if (!side) return;

      if (side === "left") {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    });
  }

  // function updateNavPosition(swiperInstance) {
  //   const $activeSlide = $(swiperInstance.slides[swiperInstance.activeIndex]);
  //   const $activeImage = $activeSlide.find("img");

  //   if (!$activeImage.length) return;

  //   // Esperar a que la imagen esté cargada
  //   if (!$activeImage[0].complete) {
  //     $activeImage.on("load", function() {
  //       applyNavPosition($(this));
  //     });
  //   } else {
  //     applyNavPosition($activeImage);
  //   }
  // }

  // function applyNavPosition($img) {
  //   const width = $img[0].naturalWidth;
  //   const height = $img[0].naturalHeight;

  //   // Detectar si es portrait o landscape
  //   const isPortrait = height > width;

  //   const $prev = $(".swiper-button-prev");
  //   const $next = $(".swiper-button-next");

  //   if (isPortrait) {
  //     // 📱 Imagen vertical
  //     $prev.css("left", "140px");
  //     $next.css("right", "140px");
  //     $prev
  //       .addClass("swiper-button-prev--portrait")
  //       .removeClass("swiper-button-prev--landscape");
  //     $next
  //       .addClass("swiper-button-next--portrait")
  //       .removeClass("swiper-button-next--landscape");
  //   } else {
  //     // 🖥 Imagen horizontal
  //     $prev.css("left", "30px");
  //     $next.css("right", "30px");
  //     $prev
  //       .addClass("swiper-button-prev--landscape")
  //       .removeClass("swiper-button-prev--portrait");
  //     $next
  //       .addClass("swiper-button-next--landscape")
  //       .removeClass("swiper-button-next--portrait");
  //   }
  // }

  function init() {
    // return early if no corresponding module present
    if (!$(".swiper").length) return;
    initHomeSlider();
    initProjectSlider();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Sliders.init);
